import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center">
      <div className="w-full grid grid-cols-1 lg:grid-cols-2 min-h-screen">
        <div className="flex flex-col justify-center px-6 md:px-12 lg:px-16 py-24 lg:py-0 order-2 lg:order-1 bg-background-50">
          <div className="max-w-xl">
            <p className="text-xs uppercase tracking-widest text-foreground-500 mb-4 font-label">
              吃瓜入口 · 永不迷路
            </p>
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight mb-6">
              第一手爆料
              <br />
              实锤证据
            </h1>
            <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-8 max-w-md">
              91EatGossip为您提供24小时不间断的明星丑闻、网红翻车、综艺内幕独家爆料。高清视频免费在线观看，吃瓜从未如此畅快！
            </p>
            <Link
              to="/category/celebrity-gossip"
              className="inline-flex items-center gap-3 bg-foreground-900 text-background-50 px-6 py-3.5 text-sm font-medium uppercase tracking-wide hover:bg-foreground-800 transition-colors group"
            >
              立即开瓜
              <span className="w-8 h-8 border border-background-400 flex items-center justify-center group-hover:border-background-200 transition-colors">
                <i className="ri-arrow-right-line text-sm" />
              </span>
            </Link>
          </div>
        </div>
        <div className="relative order-1 lg:order-2 min-h-[300px] lg:min-h-screen">
          <img
            src="https://readdy.ai/api/search-image?query=Paparazzi%20style%20celebrity%20photography%20at%20night%20event%20with%20flash%20bulbs%20warm%20spotlight%20dramatic%20high%20contrast%2C%20glamorous%20atmosphere%20with%20dark%20background%20and%20golden%20warm%20tones%2C%20editorial%20fashion%20photography%20cinematic%20grain%20texture&width=1200&height=900&seq=hero-main-01&orientation=landscape"
            alt="91EatGossip 娱乐八卦热点"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-background-50/50 via-transparent to-transparent lg:block hidden" />
        </div>
      </div>
    </section>
  );
}